export const percentageToCartesian = (radius: number, percentage: number) => {
  const angleInRadians = Math.PI / 2 - (2 * Math.PI * percentage) / 100;

  return {
    x: radius * Math.cos(angleInRadians),
    y: -radius * Math.sin(angleInRadians),
  };
};
